import React from 'react';

const DocumentTextIcon = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.2008 1.47317C10.9274 1.19983 10.4541 1.3865 10.4541 1.7665V4.09317C10.4541 5.0665 11.2808 5.87317 12.2874 5.87317C12.9208 5.87983 13.8008 5.87983 14.5541 5.87983C14.9341 5.87983 15.1341 5.43317 14.8674 5.1665C13.9074 4.19983 12.1874 2.45983 11.2008 1.47317Z"
      fill="currentColor"
    />
    <path
      d="M14.334 6.7935H12.4073C10.8273 6.7935 9.54065 5.50683 9.54065 3.92683V2.00016C9.54065 1.6335 9.24065 1.3335 8.87398 1.3335H6.04732C3.99398 1.3335 2.33398 2.66683 2.33398 5.04683V10.9535C2.33398 13.3335 3.99398 14.6668 6.04732 14.6668H11.2873C13.3407 14.6668 15.0007 13.3335 15.0007 10.9535V7.46016C15.0007 7.0935 14.7007 6.7935 14.334 6.7935ZM8.33398 11.8335H5.66732C5.39398 11.8335 5.16732 11.6068 5.16732 11.3335C5.16732 11.0602 5.39398 10.8335 5.66732 10.8335H8.33398C8.60732 10.8335 8.83398 11.0602 8.83398 11.3335C8.83398 11.6068 8.60732 11.8335 8.33398 11.8335ZM9.66732 9.16683H5.66732C5.39398 9.16683 5.16732 8.94016 5.16732 8.66683C5.16732 8.3935 5.39398 8.16683 5.66732 8.16683H9.66732C9.94065 8.16683 10.1673 8.3935 10.1673 8.66683C10.1673 8.94016 9.94065 9.16683 9.66732 9.16683Z"
      fill="currentColor"
    />
  </svg>
);

export default DocumentTextIcon;
